import React from 'react';
import axios from 'axios';
import { errorValidator } from 'util/errorValidator';
import { toast } from 'react-toastify';
import { getStore } from 'redux/storeAccess';
import { logout, setToken } from 'redux/slices/authSlice';
import { authentication } from 'firebaseconfig';
import { ensureFreshToken } from 'util/tokenRefresh';
import { isContactSignOutActive } from 'util/authEpoch';



// Please look service folder we are using in this instance there

const VerificationToast = () => (
  <div>
    <div className="toast-header">
      <p className="mr-auto">
        Your Are Not Verified <br />
        <b>
          <a href="/user-authdetails-update">
            Click Here To Complete Your Verification
          </a>
        </b>
      </p>
    </div>
  </div>
);

const apiBaseUrl =
  "Dev" === 'Live'
    ? "https://api.zapkart.com"
    : "https://ecommerceapi.riolabz.com";

const instance = axios.create({
  baseURL: apiBaseUrl
});

// runs on each request.
instance.interceptors.request.use(
  async (config) => {
    const token = await ensureFreshToken((freshToken) => {
      getStore()?.dispatch(setToken(freshToken));
    });
    config.headers.Authorization = `Bearer ${token}`;
    config.headers.deviceToken = window.localStorage.getItem('deviceToken');

    return config;
  },
  (error) => {
    errorValidator(error.response?.data);
    return Promise.reject(error);
  }
);

let alreadyShownError = false;

const showUnauthorizedError = (data) => {
  const message = data?.title || data?.message || 'Unauthorized';
  toast.error(message, { toastId: 'unauthorized-error' });
};

instance.interceptors.response.use(
  (response) => {
    if (response.config.parse) {
      //perform the manipulation here and change the response object
    }
    return response;
  },
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const silent403Paths = ['/api/v1/cart', '/api/v1/wishlist', '/api/v1/customers'];
    const shouldSilence403 =
      status === 403 &&
      silent403Paths.some((path) => requestUrl.includes(path));

    if (status === 401) {
      if (isContactSignOutActive()) {
        return Promise.reject(error);
      }
      const firebaseUser = authentication.currentUser;
      const path = window.location.pathname;
      const onAuthDetails = path === '/user-authdetails-update';
      const onLogin = path === '/login';

      // No Firebase session → invalid/stale token
      if (!firebaseUser) {
        showUnauthorizedError(error.response?.data);
        getStore()?.dispatch(logout({ showNotification: false }));
        return Promise.reject(error);
      }

      // Claim UI slot synchronously so parallel 401s (before await) don't all toast
      const claimedVerificationSlot =
        !alreadyShownError && !onLogin && !onAuthDetails;
      if (claimedVerificationSlot) {
        alreadyShownError = true;
      }

      // Same condition as BeforeAppLoad: only incomplete users go to auth-details
      return (async () => {
        try {
          const idTokenResult = await firebaseUser.getIdTokenResult();
          const userType = idTokenResult.claims.userType;
          const isNewIncompleteUser =
            userType !== 'Customer' &&
            userType !== 'Admin' &&
            userType !== 'SubAdmin' &&
            userType !== 'Vendor';

          if (isNewIncompleteUser) {
            if (claimedVerificationSlot) {
              toast.warning(VerificationToast, {
                toastId: 'verification-required'
              });
              window.location.href = '/user-authdetails-update';
              setTimeout(() => {
                alreadyShownError = false;
              }, 3000);
            }
          } else {
            // Existing Customer (or staff) — invalid token / real 401
            if (claimedVerificationSlot) {
              alreadyShownError = false;
            }
            showUnauthorizedError(error.response?.data);
            getStore()?.dispatch(logout({ showNotification: false }));
          }
        } catch {
          if (claimedVerificationSlot) {
            alreadyShownError = false;
          }
          showUnauthorizedError(error.response?.data);
          getStore()?.dispatch(logout({ showNotification: false }));
        }

        return Promise.reject(error);
      })();
    }

    if (!shouldSilence403 && !error.config?.skipGlobalError) {
      errorValidator(error.response?.data);
    }

    return Promise.reject(error);
  }
);

export default instance;
